/**
 * Configurações de Timeout - LicitarsAI Visual
 * 
 * Este arquivo centraliza todas as configurações de timeout de segurança
 * para facilitar manutenção e consistência em todo o projeto.
 */

export const TIMEOUT_CONFIG = {
  // Timeout de segurança para splash screen (2 minutos)
  SPLASH_SAFETY: 120000, // 2 minutos em milissegundos
  
  // Timeout de segurança para loading de documento (2 minutos)
  DOCUMENT_LOADING: 120000, // 2 minutos em milissegundos
  
  // Timeout de segurança para painel escondido (2 minutos)
  PANEL_HIDDEN: 120000, // 2 minutos em milissegundos
  
  // Timeout de loading de sessão (10 segundos)
  SESSION_LOADING: 10000, // 10 segundos em milissegundos
  
  // Timeout de reconexão WebSocket (30 segundos)
  WEBSOCKET_RECONNECT: 30000, // 30 segundos em milissegundos
  
  // Timeout de idle para conexões de banco (30 segundos)
  DATABASE_IDLE: 30000, // 30 segundos em milissegundos
} as const;

/**
 * Função helper para obter timeout com fallback
 */
export const getTimeout = (key: keyof typeof TIMEOUT_CONFIG, fallback?: number): number => {
  return TIMEOUT_CONFIG[key] ?? fallback ?? 30000; // 30s como fallback padrão
};

/**
 * Função helper para formatar tempo em formato legível
 */
export const formatTimeout = (timeoutMs: number): string => {
  if (timeoutMs >= 60000) {
    const minutes = Math.floor(timeoutMs / 60000);
    return `${minutes}min`;
  }
  const seconds = Math.floor(timeoutMs / 1000);
  return `${seconds}s`;
};

/**
 * Constantes para uso em logs
 */
export const TIMEOUT_LABELS = {
  SPLASH_SAFETY: formatTimeout(TIMEOUT_CONFIG.SPLASH_SAFETY),
  DOCUMENT_LOADING: formatTimeout(TIMEOUT_CONFIG.DOCUMENT_LOADING),
  PANEL_HIDDEN: formatTimeout(TIMEOUT_CONFIG.PANEL_HIDDEN),
  SESSION_LOADING: formatTimeout(TIMEOUT_CONFIG.SESSION_LOADING),
  WEBSOCKET_RECONNECT: formatTimeout(TIMEOUT_CONFIG.WEBSOCKET_RECONNECT),
  DATABASE_IDLE: formatTimeout(TIMEOUT_CONFIG.DATABASE_IDLE),
} as const; 